module.exports = __webpack_public_path__ + "img/icon_specialist_availability_calendar.6d45bf09.svg";